var _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _path7, _path8, _rect, _rect2, _path9, _path0, _rect3, _rect4, _rect5, _circle, _circle2, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagician6051 = function SvgMagician6051(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 51,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "magician_60_51_svg__a",
    width: 60,
    height: 51,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h60v51H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#magician_60_51_svg__a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magician_60_51_svg__b)",
    d: "M20.471 13.947c-.153-.874-.122-1.806.478-2.46.785-.858 2.388-1.934 5.574-2.217 2.86-.254 4.7.29 5.808.874 1.052.554 1.439 1.748 1.464 2.937l.073 3.465a6.066 6.066 0 0 1-5.724 6.182l-.713.04a6.035 6.035 0 0 1-6.286-4.982z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magician_60_51_svg__c)",
    d: "M21.046 17.527c-.059-.31.025-.628.272-.824.686-.544 2.427-1.59 5.963-1.921 3.515-.331 5.403.324 6.177.71.285.142.431.44.434.758l.075 9.06a1.07 1.07 0 0 1-1 1.077l-9.192.595a1.065 1.065 0 0 1-1.116-.866z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magician_60_51_svg__d)",
    d: "M26.992 16.081c-7.34.775-11.816 5.1-11.419 7.69.49 3.197 5.679 4.439 12.832 3.666s12.166-4.285 11.672-6.842c-.547-2.832-5.744-5.289-13.085-4.514"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.048,
    cy: 11.81,
    fill: "url(#magician_60_51_svg__e)",
    rx: 12.048,
    ry: 11.81,
    transform: "rotate(11.619 -68.288 104.22)skewX(.001)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magician_60_51_svg__f)",
    d: "M30.682 23.568c.099.65-.068 1.122-.546 1.18-.478.059-.796-.365-.83-.996-.032-.631.091-1.065.53-1.122.44-.056.748.289.846.938"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magician_60_51_svg__g)",
    d: "M25.273 23.927c-.03.655.185 1.107.667 1.115.48.008.752-.446.719-1.077-.034-.63-.293-1.05-.645-1.059-.351-.008-.711.365-.741 1.02"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magician_60_51_svg__h)",
    d: "M15.247 30.99c-.058 1.637-1.716 4.172-2.722 4.723-1.296.477-2.64.042-4.369-.685-1.59-.668-3.393-2.485-3.497-3.911-.076-1.05.89-3.572 1.916-3.838 1.306-.339 3.93 1.032 4.22 1.107.291.074.697.427.642-.334-.056-.76-.471-2.546.758-2.636.78-.056 3.11 3.944 3.052 5.575"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#magician_60_51_svg__i)",
    fillOpacity: 0.5,
    d: "M15.247 30.99c-.058 1.637-1.716 4.172-2.722 4.723-1.296.477-2.64.042-4.369-.685-1.59-.668-3.393-2.485-3.497-3.911-.076-1.05.89-3.572 1.916-3.838 1.306-.339 3.93 1.032 4.22 1.107.291.074.697.427.642-.334-.056-.76-.471-2.546.758-2.636.78-.056 3.11 3.944 3.052 5.575",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magician_60_51_svg__j)",
    d: "M48.821 21.825c.708.035 2.111.863 2.665 2.16.358.843.45 2.23-.215 3.654-.58 1.245-1.426 2.476-2.34 3.008-1.023.595-3.161.354-4.298-.147-.982-.433-1.954-1.584-1.718-2.963.206-1.213.035-1.738.233-2.951.165-1.01.773-1.938 1.492-2.324 1.129-.606 1.738-.995 2.2-.718.39.233.479.424.426.444.31-.141.847-.197 1.555-.163"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.288,
    height: 1.364,
    fill: "url(#magician_60_51_svg__k)",
    rx: 0.682,
    transform: "rotate(109.674 19.665 26.806)skewX(-.001)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 0.932,
    height: 1.364,
    fill: "url(#magician_60_51_svg__l)",
    rx: 0.466,
    transform: "matrix(.33666 -.94163 -.94162 -.33668 51.522 17.321)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magician_60_51_svg__m)",
    d: "M48.82 21.825c.709.034 2.112.863 2.665 2.16.36.842.45 2.229-.214 3.653-.58 1.246-1.426 2.476-2.341 3.009-1.022.594-1.525-1.105-2.688-1.345s-1.584-1.677-1.055-3.358c.423-1.345 1.699-3.104 2.079-3.957.31-.14.847-.197 1.555-.162"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magician_60_51_svg__n)",
    d: "M47.608 23.45c.012-.922-.292-2.204-1.325-2.3-.956-.088-1.676.555-1.773 1.703-.096 1.14.688 1.494 1.367 1.8l.014.007c.683.308 1.705-.287 1.717-1.21"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.743,
    height: 1.744,
    fill: "url(#magician_60_51_svg__o)",
    rx: 0.712,
    transform: "rotate(2.839 -208.802 1048.788)skewX(-.007)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.389,
    height: 1.389,
    fill: "url(#magician_60_51_svg__p)",
    rx: 0.694,
    transform: "matrix(.88764 -.46058 .4605 .88763 46.578 14.423)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.453,
    height: 1.453,
    fill: "url(#magician_60_51_svg__q)",
    rx: 0.712,
    transform: "matrix(.7804 .62523 -.62525 .78045 54.534 16.675)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0.726,
    cy: 0.726,
    r: 0.726,
    fill: "url(#magician_60_51_svg__r)",
    transform: "rotate(.451 -1495.535 6230.206)skewX(-.007)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.872,
    cy: 0.872,
    r: 0.872,
    fill: "url(#magician_60_51_svg__s)",
    transform: "rotate(.451 -1721.107 6898.57)skewX(-.007)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#magician_60_51_svg__t)",
    d: "M25.09 27.281c-.292-1.179-.032-1.233.935-1.281s3.392-.261 4.367-.398 1.157-.374 1.2.91-.611 2.35-2.768 2.674-3.442-.726-3.734-1.905"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "magician_60_51_svg__b",
    x1: 34.118,
    x2: 20.954,
    y1: 15.846,
    y2: 16.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magician_60_51_svg__c",
    x1: 34.01,
    x2: 21.703,
    y1: 20.026,
    y2: 20.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4287FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#85B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#89B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4287FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magician_60_51_svg__h",
    x1: 12.284,
    x2: 9.214,
    y1: 25.352,
    y2: 35.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magician_60_51_svg__j",
    x1: 49.561,
    x2: 43.03,
    y1: 26.463,
    y2: 25.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magician_60_51_svg__k",
    x1: 1.421,
    x2: 17.385,
    y1: 0.587,
    y2: 0.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3A3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magician_60_51_svg__l",
    x1: 0.077,
    x2: 0.937,
    y1: 0.587,
    y2: 0.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEBC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magician_60_51_svg__m",
    x1: 51.563,
    x2: 45.388,
    y1: 26.957,
    y2: 25.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magician_60_51_svg__n",
    x1: 47.199,
    x2: 44.366,
    y1: 22.537,
    y2: 23.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magician_60_51_svg__o",
    x1: 0.872,
    x2: 1.34,
    y1: 0,
    y2: 1.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFF7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magician_60_51_svg__p",
    x1: 0.695,
    x2: 1.067,
    y1: 0,
    y2: 1.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFF7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magician_60_51_svg__q",
    x1: 0.726,
    x2: 1.116,
    y1: 0,
    y2: 1.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFF7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magician_60_51_svg__r",
    x1: 0.726,
    x2: 1.116,
    y1: 0,
    y2: 1.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFF7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magician_60_51_svg__s",
    x1: 0.872,
    x2: 1.34,
    y1: 0,
    y2: 1.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFF7D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "magician_60_51_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.13194 -10.187 15.62514 -1.73621 27.676 26.298)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545454"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "magician_60_51_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(81.574 2.424 8.612)scale(19.6271 20.0276)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#FFF9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.877,
    stopColor: "#FFE68D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "magician_60_51_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(103.755 6.088 23.164)scale(1.68848 1.56722)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "magician_60_51_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(70.221 -3.48 29.897)scale(1.6872 1.56604)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "magician_60_51_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.54314 3.3572 -5.04287 8.32638 8.96 29.735)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "magician_60_51_svg__t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-64.776 37.38 -8.071)scale(4.16336 6.26035)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    stopColor: "#F77E74"
  })))));
};
export default SvgMagician6051;